const types = {
    SAVE_CURRENT_PERFORMANCE: 'competeCompany/SAVE_CURRENT_PERFORMANCE',
    SAVE_ENROLL_PARAMS: 'competeCompany/SAVE_ENROLL_PARAMS',
};

export const saveCurrentPerformance = current => ({
    type : types.SAVE_CURRENT_PERFORMANCE,
    current,
})

export const saveEnrollParams = params => ({
    type: types.SAVE_ENROLL_PARAMS,
    params,
});

const initState = {
    current: 1,
    params: {},
};

const competeCompanyReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_CURRENT_PERFORMANCE:
            return { ...state, current: actions.current }
        case types.SAVE_ENROLL_PARAMS:
            return { ...state, params: { ...actions.params } };
        default:
            return state;
    }
}

export default competeCompanyReducer;


// WEBPACK FOOTER //
// ./src/actions/competeCompanyActions.js